import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { take, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanLoad {
  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UserService, ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      return combineLatest(this.authService.authState, this.authService.initialized)
        .pipe(
          take(1),
          map(([authState, init]) => authState),
          map(authState => !!authState),
          tap(loggedIn => {
            if (!loggedIn) {
              this.router.navigate(['/login']);
            } else {
              const activeUser = this.authService.activeUser;
              if (activeUser && activeUser.isAdmin) {
                return true;
              } else {
                this.router.navigate(['/home']);
              }
            }
          })
        );
  }
}
